<template>
  <vs-popup class="customer-sample-order-create-popup"
            id="popup"
            :title="`${doc_type}`"
            @close="onClickClose()"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <div class="vx-row mx-2 shipment-document-create-page">
        <div class="vx-row mx-2">
          <div class="vx-col md:w-1/4 w-full md:mb-0" v-for="(doc, index_doc) in docFiles" :key="index_doc">
            <feather-icon @click="onClickDoc(doc)" icon="FileIcon" svgClasses="stroke-current text-primary w-24 h-24" class="ml-1 pointer-cursor" />
            <br>
            <a :href="doc" target="_blank" class="ml-4 font-bold mb-2">{{ __nameSplitter(doc) }}</a> <br>
          </div>
        </div>
      </div>
    </vx-card>
  </vs-popup>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
const CourierRepository = RepositoryFactory.get('courier')
const FormulationsRepository = RepositoryFactory.get('formulations')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    documents: [],
    doc_type: ''
  }
}

export default {
  name: "ShipmentDocumentView",
  data() {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  computed: {
    docFiles() {
      return (this.documents && this.documents.length && this.documents[0] && Array.isArray(this.documents[0].files))
        ? this.documents[0].files
        : []
    }
  },
  methods: {
    async openPopup(documents, doc_type) {
      try {
        await Object.assign(this.$data, initialState())
        this.documents = documents
        this.doc_type = doc_type
        this.open = true
      } catch (error) {

      }
    },
    onClickDoc(url) {
      window.open(url, '_blank');
    },
    onClickClose() {
      this.open = false
      this.$emit('onClickCloseDocs', '')
    }
  },
}
</script>

<style scoped>
.shipment-document-create-page >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 70% !important;
}

.dropdown-menu {
  z-index: 10030 !important;
}
</style>
